export default [
  {
    name: 'inStorageList',
    path: '/officeSuppliers/inStorage/inStorageList',
    component: () => import('@/views/officeSupplies/inStorage/inStorageList.vue'),
    meta: {
      title: '办公用品入库单列表'
    }
  },
  {
    name: 'inStorageDetail',
    path: '/officeSuppliers/inStorage/inStorageDetail',
    component: () => import('@/views/officeSupplies/inStorage/inStorageDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/inStorage/inStorageList',
      notCache: true,
      title: '办公用品入库单详情'
    }
  },
  {
    name: 'inStorageForm',
    path: '/officeSuppliers/inStorage/inStorageForm',
    component: () => import('@/views/officeSupplies/inStorage/inStorageForm.vue'),
    meta: {
      parentAuth: '/officeSuppliers/inStorage/inStorageList',
      title: '新增办公用品入库单'
    }
  },
  {
    name: 'purchaseList',
    path: '/officeSuppliers/purchase/purchaseList',
    component: () => import('@/views/officeSupplies/purchase/purchaseList.vue'),
    meta: {
      title: '办公用品采购订单'
    }
  },
  {
    name: 'purchaseForm',
    path: '/officeSuppliers/purchase/purchaseForm',
    component: () => import('@/views/officeSupplies/purchase/purchaseForm.vue'),
    meta: {
      parentAuth: '/officeSuppliers/purchase/purchaseList',
      title: '新增采购订单'
    }
  },
  {
    name: 'purchaseDetail',
    path: '/officeSuppliers/purchase/purchaseDetail',
    component: () => import('@/views/officeSupplies/purchase/purchaseDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/purchase/purchaseList',
      title: '采购订单详情'
    }
  },
  {
    name: 'officePurchaseList',
    path: '/officeSuppliers/officePurchase/officePurchaseList',
    component: () => import('@/views/officeSupplies/officePurchase/officePurchaseList.vue'),
    meta: {
      title: '办公用品采购清单'
    }
  }, {
    name: 'officePurchaseForm',
    path: '/officeSuppliers/officePurchase/officePurchaseForm',
    component: () => import('@/views/officeSupplies/officePurchase/officePurchaseForm.vue'),
    meta: {
      parentAuth: '/officeSuppliers/officePurchase/officePurchaseList',
      title: '新增采购申请单'
    }
  },
  {
    name: 'officePurchaseDetail',
    path: '/officeSuppliers/officePurchase/officePurchaseDetail',
    component: () => import('@/views/officeSupplies/officePurchase/officePurchaseDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/officePurchase/officePurchaseList',
      title: '采购申请单详情'
    }
  },
  {
    name: 'outStorageList',
    path: '/officeSuppliers/outStorage/outStorageList',
    component: () => import('@/views/officeSupplies/outStorage/outStorageList.vue'),
    meta: {
      title: '办公用品出库单'
    }
  },
  {
    name: 'outStorageForm',
    path: '/officeSuppliers/outStorage/outStorageForm',
    component: () => import('@/views/officeSupplies/outStorage/outStorageForm.vue'),
    meta: {
      parentAuth: '/officeSuppliers/outStorage/outStorageList',
      title: '新增办公用品领用出库'
    }
  },
  {
    name: 'outStorageDetail',
    path: '/officeSuppliers/outStorage/outStorageDetail',
    component: () => import('@/views/officeSupplies/outStorage/outStorageDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/outStorage/outStorageList',
      title: '出库单详情'
    }
  },
  {
    name: 'outStorageListNeedList',
    path: '/officeSuppliers/need/needList',
    component: () => import('@/views/officeSupplies/need/needList.vue'),
    meta: {
      title: '办公用品需求清单'
    }
  },
  {
    name: 'needDetail',
    path: '/officeSuppliers/need/needDetail',
    component: () => import('@/views/officeSupplies/need/needDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/need/needList',
      title: '办公用品需求申请单详情'
    }
  },
  {
    name: 'officeTypeList',
    path: '/officeSuppliers/officeTypeList/typeList',
    component: () => import('@/views/officeSupplies/officeTypeList/typeList.vue'),
    meta: {
      title: '办公用品维护'
    }
  },
  {
    name: 'typeForm',
    path: '/officeSuppliers/officeTypeList/typeForm',
    component: () => import('@/views/officeSupplies/officeTypeList/typeForm.vue'),
    meta: {
      parentAuth: '/officeSuppliers/officeTypeList/typeList',
      title: '办公用品维护新增'
    }
  },
  {
    name: 'typeDetail',
    path: '/officeSuppliers/officeTypeList/typeDetail',
    component: () => import('@/views/officeSupplies/officeTypeList/typeDetail.vue'),
    meta: {
      parentAuth: '/officeSuppliers/officeTypeList/typeList',
      title: '办公用品维护详情'
    }
  },
]
